import React from 'react';
import { Phone, Mail, Youtube, MapPin, Facebook, Linkedin } from 'lucide-react';
import { contactInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-forest-green text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_authentic-ayurveda-2/artifacts/xevqzcml_image.png" 
                alt="Vedankur Ayurveda" 
                className="h-12 w-12 object-contain bg-white rounded-full p-1"
              />
              <div>
                <h3 className="text-2xl font-serif font-bold">Vedankur Ayurveda</h3>
                <p className="text-xs text-sage-green">Panchakarma Centre</p>
              </div>
            </div>
            <p className="text-cream leading-relaxed mb-6">
              Bridging ancient Ayurvedic wisdom with modern clinical precision. 
              Experience authentic healing for your mind, body, and soul.
            </p>
            <div className="flex gap-3">
              <a
                href={contactInfo.youtubeChannel}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-sage-green hover:bg-white hover:text-forest-green rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="YouTube Channel"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.facebookPage}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-sage-green hover:bg-white hover:text-forest-green rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="Facebook Page"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.linkedinProfile}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-sage-green hover:bg-white hover:text-forest-green rounded-full flex items-center justify-center transition-all duration-300 transform hover:scale-110"
                aria-label="LinkedIn Profile"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-serif font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-cream hover:text-white transition-colors duration-300">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-cream hover:text-white transition-colors duration-300">
                  Services
                </a>
              </li>
              <li>
                <a href="#about" className="text-cream hover:text-white transition-colors duration-300">
                  About Us
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-cream hover:text-white transition-colors duration-300">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-cream hover:text-white transition-colors duration-300">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-serif font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-sage-green flex-shrink-0 mt-1" />
                <div>
                  <p className="text-cream font-medium">Main Office</p>
                  <a href={`tel:${contactInfo.phone}`} className="text-cream hover:text-white transition-colors">
                    {contactInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-sage-green flex-shrink-0 mt-1" />
                <div>
                  <p className="text-cream font-medium">Dr. Sameer Jondhale</p>
                  <a href={`tel:${contactInfo.drSameerPhone}`} className="text-cream hover:text-white transition-colors">
                    {contactInfo.drSameerPhone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-sage-green flex-shrink-0 mt-1" />
                <a href={`mailto:${contactInfo.email}`} className="text-cream hover:text-white transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-sage-green flex-shrink-0 mt-1" />
                <a 
                  href={contactInfo.location.mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-cream hover:text-white transition-colors"
                >
                  {contactInfo.address}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-sage-green/30 mt-12 pt-8 text-center">
          <p className="text-cream">
            © {currentYear} Vedankur Ayurveda. All rights reserved. | Designed with care for your wellness journey.
          </p>
        </div>
      </div>
    </footer>
  );
};
